import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
// Translation provided by Vuetify (javascript)
import pt from 'vuetify/lib/locale/pt'
// import VueTheMask from 'vue-the-mask'
//import VueCanCan from 'vue-cancan'
import '@mdi/font/css/materialdesignicons.css'

// import { aliases, mdi } from 'vuetify/iconsets/mdi' //adicionado novo, tirar se nao funcionar
// import i18n from '@/plugins/i18n';

import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker)
//Vue.use(VueCanCan, {rules: window.abilities})

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);


import _ from 'lodash'
Vue.prototype._ = _

import 'cleave.js/dist/cleave.min.js'
// import phoneCleave from 'cleave.js/dist/addons/cleave-phone.br'

import router from './routes.js';
import {
  ApolloClient
} from 'apollo-client'
import {
  createHttpLink
} from 'apollo-link-http'
import {
  InMemoryCache
} from 'apollo-cache-inmemory'

import VueApollo from 'vue-apollo'
import moment from "moment";

Vue.use(require('vue-shortkey'))

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

//global functions
import { autocompleteCustomFilter } from './global_functions.js'

Vue.prototype.$customFilter = autocompleteCustomFilter

// import VueApexCharts from 'vue-apexcharts'

// import jsPDF from 'jspdf'
// import html2canvas from "html2canvas"

import { abilitiesPlugin } from '@casl/vue'
import ability from './ability'
Vue.use(abilitiesPlugin, ability)

// import { VMaskInput } from 'vuetify/labs/VMaskInput';
// Vue.use(VMaskInput);

import App from './app.vue'
import Site from './site.vue'
import PrivacyPolicy from './privacy_policy.vue'

import 'chartjs-plugin-colorschemes/dist/chartjs-plugin-colorschemes.min.js'
import VueCharts from 'vue-chartjs'
// import Chartkick from 'vue-chartkick'
// Vue.use(Chartkick)
// Vue.use(Chartkick.use(Chart))
import {
  DynamicReactiveRefs
} from 'vue-reactive-refs'


Vue.use(DynamicReactiveRefs)

Vue.use(Vuetify)
Vue.use(VueApollo)
Vue.use(VueCharts)
// Vue.use(VueTheMask)
// Vue.use(Quasar)
// Vue.use(VueApexCharts)
// Vue.component('apexchart', VueApexCharts)

Vue.filter('formatDate', function (value) {
  return globalFormatDate(value);
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatDecimalNumber', function (value) {
  if (value || value === 0) {
    return value.toString().replace(".", ",")
  }
})

Vue.filter('formatCurrency', (value) => {
  if (value || value === 0) {
    return globalNumberToCurrency(value);
  }
})

Vue.filter('formatCurrency_10d', (value) => {
  if (value || value === 0) {
    return globalNumberToCurrency(value, 10);
  }
})

Vue.filter('formatNumber', (value) => {
  if (value || value === 0) {
    return globalNumberToDecimal(value);
  }
})

Vue.filter('formatNfeSeries', (value) => {
  if (value) {
    return globalNfeField(value, 3);
  }
})

Vue.filter('formatNfeNumber', (value) => {
  if (value) {
    return globalNfeField(value, 9);
  }
})

function globalFormatDate(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
}

function globalNumberToCurrency(number, maxFractionDigits = 2) {
  return new Intl.NumberFormat("pt-br", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: maxFractionDigits
  }).format(number);
}

function globalNumberToAbbrviatedCurrency(number, maxFractionDigits = 2) {
  return new Intl.NumberFormat("pt-br", {
    style: "currency",
    currency: "BRL",
    notation: 'compact',
    compactDisplay: 'short'
  }).format(number);
}

function globalNumberToDecimal(number) {
  return new Intl.NumberFormat("pt-br", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 10
  }).format(number);
}

function globalNfeField(value, number_digits) {
  return value.toString().padStart(number_digits, "0")
}

function globalNumberToPercentage(number) {
  return new Intl.NumberFormat("pt-br", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 10
  }).format(number) + "%";
}

function globalDeepFilterEntryWithAllowedFieldsForMutation(entry, entryValidations) {
  var cloneEntry = _.cloneDeep(entry);
  var allowedFieldsNames = Object.keys(entryValidations);

  var allowedEntry = _.pickBy(cloneEntry, function (value, key) {
    if ((key.indexOf("Attributes") > 0 || key == "initialPurchaseItems") && entryValidations[key]) {
      if (Array.isArray(cloneEntry[key])) {
        for (var item in value) {
          value[item] = globalDeepFilterEntryWithAllowedFieldsForMutation(value[item], entryValidations[key]);
        }
      }
    }
    return allowedFieldsNames.includes(key);
  });

  for (var item in allowedEntry) {
    if (item.indexOf("Attributes") > 0 || item == "initialPurchaseItems") {
      if (!Array.isArray(allowedEntry[item])) {
        allowedEntry[item] = globalDeepFilterEntryWithAllowedFieldsForMutation(allowedEntry[item], entryValidations[item]);
      }
    }
  }
  return allowedEntry;
}

const CURRENT_USER_QUERY = gql`
{
  userContext {
    currentUser {
      id
      email
      isExpired
      isAltavenda
      expirationDays
      person {
        id
        name
      }
      groundId
      ground {
        name
        logo
      }
      accountId
      account {
        id
        hasCerealProducerBusinessActivity
        hasFlvProducerBusinessActivity
        hasSeedlingProducerBusinessActivity
        businessActivities {
          id
          name
          code
          isCerealProducer
          isFlvProducer
          isSeedlingProducer
        }
      }
    }
  }
}
`;

const normalizeString = (s, transform = s => s.toLocaleLowerCase()) => {
  let normalized = transform(s);
  if (String.prototype.normalize) {
    try {
      normalized = normalized.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    } catch (e) {
      // just ignore
    }
  }
  return normalized;
};

// module.exports = normalizeString;

Vue.mixin({
  data() {
    return {
      requiredRule: v => !!v || v === 0 || v === false || 'Este campo é obrigatório',
      minRequiredRule: v => (v && this.convertToNumberWithoutRounding(v) > 0) || 'Valor deve ser maior do 0',
      minArrayRequiredRule: v => (v && v.length > 0) || 'Pelo menos 1 item deve ser selecionado',
      greaterThanRule: min => v => (v && this.convertToNumberWithoutRounding(v) > min) || 'Valor deve ser maior do que ' + min,
      greaterThanOrEqualToRule: min => v => ((v || v === 0) && this.convertToNumberWithoutRounding(v) >= min) || 'Valor deve ser maior ou igual a ' + min,
      minLengthRule: min => v => (v && v.trim().length >= min) || 'Minímo de ' + min + ' caractere' + (min > 1 ? 's' : ''),
      minLengthAllowBlankRule: min => v => (!v || (v && v.trim().length >= min)) || 'Minímo de ' + min + ' caractere' + (min > 1 ? 's' : ''),
      maxValueRule: max => v => (v && this.convertToNumberWithoutRounding(v) <= max) || 'Valor máximo de ' + this.numberToDecimal(max),
      maxCurrencyRule: max => v => (v && this.convertToNumberWithoutRounding(v) <= max) || 'Valor máximo de ' + this.numberToCurrency(max),
      maxCurrencyRuleAllowZero: max => v => ((v || v === 0) && this.convertToNumberWithoutRounding(v) <= max) || 'Valor máximo de ' + this.numberToCurrency(max),
      inListRule: list => v => (list.includes(v)) || 'O valor informado não é permitido',
      isExactLengthRule: exact => v => (v && _.replace(v, /[\-\.,\\/ ]/g, '').length == exact) || 'Este campo deve conter exatamente ' + exact + ' caractere' + (exact > 1 ? 's' : ''),
      isExactLengthAllowBlankRule: exact => v => (!v || (v && _.replace(v, /[\-\.,\\/ ]/g, '').length == exact)) || 'Este campo deve conter exatamente ' + exact + ' caractere' + (exact > 1 ? 's' : ''),
      blurElementAfterSelect: () => document.activeElement.blur(),
      emailRule: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
    }
  },
  methods: {
    getCurrentUser: function (callback) {
      // console.log("get current user");

      this.$apollo
        .query({
          query: CURRENT_USER_QUERY,
          fetchPolicy: "cache-first"
        })
        .then(response => {
          // console.log("RESPONSE ", response);
          // navigator.notification.alert("message" + response, () => {}, "title", "button title");
          // window.alert(JSON.stringify(response))

          if (callback) {
            callback(response.data.userContext.currentUser);
          }
          // this.$root.$data.appLoading = false;
          // localStorage.setItem('LOCAL_USER', response.data.userContext.currentUser);
          // this.$root.$data.localUser = response.data.userContext.currentUser;
          // apollo.cache.writeData({
          //   data: response.data,
          // });
          // localUser = response.data.currentLocalUser;
        })
        .catch((response) => {
          // alert(response)
          // let errorMessageTest = response;
          // let error = errorMessageTest;
          // callback(null, error);

          console.log("RESPONSE CATCH", response);
          // location.reload();
          this.$router.push({ path: "/users/sign_in" });
        })
        .finally(() => (true));
    },
    // filterEntryWithAllowedFieldsForMutation: function(entry, entryAttributes) {
    //   var cloneEntry = _.cloneDeep(entry);
    //   var allowedFieldsNames = Object.keys(_.pickBy(entryAttributes, function(value, key) {
    //     return value.mutationInput;
    //   }));

    //   var allowedEntry = _.pickBy(cloneEntry, function(value, key) {
    //     return allowedFieldsNames.includes(key)
    //   });

    //   var attributesKeys = Object.keys(_.pickBy(allowedEntry, function(value, key) {
    //     return key.indexOf("Attributes") > 0;
    //   }));

    //   attributesKeys.forEach(function(key,index) {
    //     for (var item in allowedEntry[key]) {
    //       var allowedNestedEntry = Object.keys(entryAttributes[key]);
    //       allowedEntry[key][item] = _.pickBy(allowedEntry[key][item], function(value, keyNested){
    //         return allowedNestedEntry.includes(keyNested);
    //       });
    //     }
    //   });
    //   return allowedEntry;
    // },
    deepFilterEntryWithAllowedFieldsForMutation: function (entry, validations) {
      // console.log("MIXIN", entry, validations);
      return globalDeepFilterEntryWithAllowedFieldsForMutation(entry, validations);
    },
    convertToNumber: function (value) {
      var num = value.toString();
      num = _.replace(num, /\./g, "");
      num = num.replace(",", ".");
      return parseFloat(num).toFixed(2);
    },
    convertToNumberWithoutRounding: function (value) {
      var num = value.toString();
      num = _.replace(num, /\./g, "");
      num = num.replace(",", ".");
      return parseFloat(num);
    },
    numberToCurrency: function (number) {
      return globalNumberToCurrency(number);
    },
    numberToAbbrviatedCurrency: function (number) {
      return globalNumberToAbbrviatedCurrency(number);
    },
    numberToDecimal: function (number) {
      return globalNumberToDecimal(number);
    },
    numberToPercentage: function (number) {
      return globalNumberToPercentage(number);
    },
    formatDate: function (value) {
      return globalFormatDate(value);
    },
    forceRerender(element) {
      // Remove my-component from the DOM
      element.renderComponent = false;

      element.$nextTick(() => {
        // Add the component back in
        element.renderComponent = true;
      });
    },
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    setupEntryAttributes(entry, entryAttributes = {}) {
      Object.keys(entry).forEach(key => {
        if (key != "__typename" && key != "validations") {
          if (!entryAttributes[key]) {
            entryAttributes[key] = {};
          }

          if (entry.validations && entry.validations[key]) {
            // Caso o atributo(key) esteja na lista de validations, o mesmo poderá ser enviado no mutation de criação/edição
            // TODO(THiago): rever a necessidade da variável mutationInput aqui
            entryAttributes[key].mutationInput = true
            _.merge(entryAttributes[key], entry.validations[key])
          }

          entryAttributes[key].ref = key;
          if (!entryAttributes[key].rules) {
            entryAttributes[key].rules = [];
          }
          // if (entry.validations && entry.validations[key]) {
          // console.log(entryAttributes[key])
          if (entryAttributes[key].required) {
            entryAttributes[key].rules.push(this.requiredRule);
          }
          if (entryAttributes[key].minLength) {
            if (entryAttributes[key].allowNil) {
              entryAttributes[key].rules.push(this.minLengthAllowBlankRule(entry.validations[key].minLength));
            } else {
              entryAttributes[key].rules.push(this.minLengthRule(entry.validations[key].minLength));
            }
          }
          if (entryAttributes[key].greaterThanOrEqualTo || entryAttributes[key].greaterThanOrEqualTo == 0) {
            entryAttributes[key].rules.push(this.greaterThanOrEqualToRule(entryAttributes[key].greaterThanOrEqualTo))
          }
          if (entryAttributes[key].greaterThan || entryAttributes[key].greaterThan == 0) {
            entryAttributes[key].rules.push(this.greaterThanRule(entryAttributes[key].greaterThan))
          }
          if (entryAttributes[key].in) {
            entryAttributes[key].rules.push(this.inListRule(entry.validations[key].in));
          }
          if (entryAttributes[key].exactLength) {
            if (entryAttributes[key].allowNil) {
              entryAttributes[key].rules.push(this.isExactLengthAllowBlankRule(entry.validations[key].exactLength));
            } else {
              entryAttributes[key].rules.push(this.isExactLengthRule(entry.validations[key].exactLength));
            }

          }
          // }
          if (!entryAttributes[key].events) {
            entryAttributes[key].events = [];
          }
        }

        this.$watch(`$refs.${key}`, (ref, old_value) => {
          if (ref) {
            // if (ref.$options._componentTag ==  "MaskedTextField") {
            //   //TODO(Thiago): Verificar se os eventos já existem antes de inserir novamente
            //   entryAttributes[key].events.push({'input-raw-data': function(event) {
            //     entry[key] =  event
            //   }})
            // }

            for (var event of entryAttributes[key].events) {
              var eventName = Object.keys(event)[0]
              var eventFunction = event[eventName]
              ref.$off(eventName)
              ref.$on(eventName, eventFunction);
            }
          }
        });
      });
      return entryAttributes;

      // var self = this;
      // this.mainObject['teste'] = {
      //   'mask-type': "currency",
      //   'rules': this.currencyRules,
      //   'label': "Valor",
      //   'prefix': "R$",
      //   'ref': 'teste',
      //   'events': {}
      //   //'events': {'input-raw-data': function(event) {self.modelCurrency =  event}}
      // };
    },
    removeExtraFields: function (object, fields = []) {
      var defaultExtraFields = ['__typename'];
      var extraFields = defaultExtraFields.concat(fields);

      for (var i = 0; i < extraFields.length; i++) {
        if (object[extraFields[i]]) {
          delete object[extraFields[i]];
        }
      }
    },
    clearFieldValue: function (field) {
      this.$nextTick(() => field = null);
    },
    filterNormalizedTextItems(item, queryText, itemText) {
      // console.log(item, queryText, itemText, normalizeString(itemText));
      if (queryText === null || queryText.length === 0) {
        return true;
      }

      return (
        itemText &&
        itemText.length > 0 &&
        normalizeString(itemText).indexOf(normalizeString(queryText)) > -1
      );
    }

    // addEntryEvents(entry, entryAttributes, mainElement) {
    //   // console.log("addEntryEvents", entry, entryAttributes, mainElement);
    //   Object.keys(entryAttributes).forEach(key => {
    //     // console.log("key", key, mainElement.$refs[key]);
    //     if (mainElement.$refs[key] && mainElement.$refs[key].$options._componentTag ==  "MaskedTextField") {
    //       // if (entryAttributes[key].events) {
    //         // TODO(Thiago): rever, o events é um array e não um hash!!!!!
    //         // entryAttributes[key].events['input-raw-data'] = function(event) {entry[key] =  event};
    //       // } else {
    //         console.log("masked")
    //         entryAttributes[key].events.push({'input-raw-data': function(event) {entry[key] =  event}})
    //       // }
    //     }
    //     for (event of entryAttributes[key].events) {
    //       var eventName = Object.keys(event)[0]
    //       console.log(this.entryAttributes[key].ref)
    //       console.log(mainElement.$refs)
    //       // mainElement.$refs[entryAttributes[key].ref].$on(eventName, event[eventName]);
    //     }
    //     // Object.keys(entryAttributes[key].events).forEach(eventKey => {
    //     //   console.log(eventKey)
    //     //   mainElement.$refs[this.entryAttributes[key].ref].$on(eventKey, entryAttributes[key].events[eventKey]);
    //     // });
    //   });
    // },

  },
  created() {
    // https://forum.vuejs.org/t/dynamic-props-and-custom-event-emit-in-dynamic-component/10932/2
    // https://forum.vuejs.org/t/access-component-data-via-directive/41059
    Vue.directive('DynamicEvents', {
      bind: function (el, binding, vnode) {
        // const allEvents = binding.value;
        // console.log("DynamicEvents bind", el, binding, vnode)
        // allEvents.forEach((event) => {
        //   // register handler in the dynamic component
        vnode.componentInstance.$on("input-raw-data", (eventData) => {
          // console.log("input-raw-data", eventData)
          // console.log(el, binding, vnode)
          el.value = 50
          // this.entry[key] =  event
          //     // when the event is fired, the proxyEvent function is going to be called
          //     vnode.context.proxyEvent(event, eventData);
        });
        // });
      },
      unbind: function (el, binding, vnode) {
        vnode.componentInstance.$off();
      },
    })

    // console.log("Create MIXIN");

    // document.querySelectorAll('.v-autocomplete input').setAttribute('onchange', function(){ document.activeElement.blur(); });

    // document.querySelectorAll('.v-autocomplete input').forEach(function (e) {
    //   e.addEventListener('onchange', function (event) {
    //     console.log('Oh dang, you just clicked!');
    //     document.activeElement.blur();
    //   });
    // });


  },
  mounted() {
    // var self = this;
    // Object.keys(this.entryAttributes).forEach(key => {
    //   if (this.$refs[key] && this.$refs[key].$options._componentTag ==  "MaskedTextField") {
    //     if (this.entryAttributes[key].events) {
    //       this.entryAttributes[key].events['input-raw-data'] = function(event) {self.entry[key] =  event};
    //     } else {
    //       this.entryAttributes[key].events = {'input-raw-data': function(event) {self.entry[key] =  event}};
    //     }
    //   }
    //   Object.keys(this.entryAttributes[key].events).forEach(eventKey => {
    //     this.$refs[this.entryAttributes[key].ref].$on(eventKey, this.entryAttributes[key].events[eventKey]);
    //   });
    // });
  },
})



const csrfToken = document.querySelector('meta[name=csrf-token]').getAttribute('content');

const httpLink = createHttpLink({
  // You should use an absolute URL here
  // uri: 'http://192.168.1.31:3000/graphql',
  uri: window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/graphql',
  // uri: 'http://localhost:3000/graphql',
  credentials: 'same-origin',
  headers: {
    'X-CSRF-Token': csrfToken
  }
})

// Cache implementation
// https://vue-apollo.netlify.com/guide/local-state.html#extending-a-remote-graphql-schema-locally
const cache = new InMemoryCache()

import gql from 'graphql-tag';

// export const typeDefs = gql`
//   type CurrentLocalUser {
//     id: ID!
//     groundId: ID!
//     name: String!
//     email: String!
//   }
// `;

// Create the apollo client
const apolloClient = new ApolloClient({
  link: httpLink,
  cache,
  // typeDefs,
  resolvers: {},
  connectToDevTools: true
});

// cache.writeData({
//   data: {
//     currentLocalUser: {
//       __typename: 'CurrentLocalUser',
//       id: '1',
//       groundId: '1',
//       name: "Felipe",
//       email: "felipe@mail.com"
//     },
//   },
// });

// import gql from 'graphql-tag';


const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

// Quasar.lang.set(Quasar.lang.ptBr)


// const icons = {
//   defaultSet: "mdi",
//   sets: {
//     mdi,
//   },
// }

function appEventListener() {
  const app = new Vue({
    el: '#app',
    router: router,
    apolloProvider,
    vuetify: new Vuetify({
      lang: {
        locales: {
          pt
        },
        current: 'pt',
      },
      // icons,
    }),

    render: h => h(App)
  });
  // app.config.globalProperties.window = window
}

document.removeEventListener('DOMContentLoaded', appEventListener)
document.addEventListener('DOMContentLoaded', appEventListener)

// function siteEventListener(){
//   const app = new Vue({
//     el: '#site',
//     // router: router,
//     apolloProvider,
//     vuetify: new Vuetify({
//       lang: {
//         locales: {
//           pt
//         },
//         current: 'pt',
//       },
//     }),
//     render: h => h(Site)
//   })
// }
//
// document.removeEventListener('DOMContentLoaded', siteEventListener)
// document.addEventListener('DOMContentLoaded', siteEventListener)
